import React from 'react';
import { DatePicker } from '@morressier/alembic';
import { Flex } from '@chakra-ui/react';
import { FieldLabel } from 'src/components/Field';
import { FieldError as IFieldError, useFormContext } from 'react-hook-form';
import _ from 'lodash';
import { FormFieldDateInput } from '@publishing-engine/domain/types/article';
import FormFieldErrorMessage from './common/FormFieldErrorMessage';

interface IFormFieldDateProps {
  config: FormFieldDateInput;
  isEditingAllowed?: boolean;
}

const FormFieldDate: React.FC<IFormFieldDateProps> = ({
  config,
  isEditingAllowed = true
}) => {
  const {
    params: { validations, labels },
    caseDataFields: { main: fieldPath }
  } = config;

  const {
    formState: { errors },
    register,
    watch
  } = useFormContext();

  const error = _.get(errors, fieldPath) as IFieldError;
  const value = watch(fieldPath) as string;

  return (
    <Flex flexDirection="column" gap={2} alignItems="flex-start">
      <FieldLabel
        label={labels.main}
        subText={labels.subtitle}
        isRequired={validations.required}
        helpText={labels.helpText}
      />
      <Flex flexDirection="column" flex={1} width={'100%'} gap={2}>
        <DatePicker
          value={value}
          {...register(fieldPath)}
          isInvalid={Boolean(error)}
          min={validations.min}
          max={validations.max}
          isReadOnly={!isEditingAllowed}
          isDisabled={!isEditingAllowed}
        />
        <FormFieldErrorMessage config={config} />
      </Flex>
    </Flex>
  );
};

export default FormFieldDate;
